import {
  useRouter,
  useRoute,
  Router,
  RouteLocationNormalizedLoadedGeneric,
} from 'vue-router';
import { Store, useStore } from 'vuex';

export interface ContextRoot {
  root: {
    $router: Router;
    $route: RouteLocationNormalizedLoadedGeneric;
    $store: Store<any>;
  };
}

export const useContextRoot = (): ContextRoot => {
  const router = useRouter();
  const route = useRoute();
  const store = useStore();

  return {
    root: {
      $router: router,
      $route: route,
      $store: store,
    },
  };
};
